import React from 'react'
import CustomerCell from './@components/CustomerCell'

export default function customerColumn() {
    return {
        name: 'customerName', label: 'Customer',
        options: {
            filter: true,
            sort: true,
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center' } }),
            customBodyRowRenderLite: (value, row) => <CustomerCell customerName={value} customerID={row.customerID} />,
        }
    }
}
